import { helpers } from '@helpers';

// Take in ref and finds current on its own, else assumes already current
export const FOCUS_NOW = async reference => {
  if (reference?.current) {
    if (helpers.isWeb) {
      reference.current?.focus({ preventScroll: true });
    } else {
      await reference.current?.setNativeProps({
        hasTVPreferredFocus: true,
      });
      reference.current?.setNativeProps({
        hasTVPreferredFocus: false,
      });
    }
  } else if (helpers.isWeb) {
    reference?.focus && reference.focus({ preventScroll: true });
  } else {
    await reference?.setNativeProps({
      hasTVPreferredFocus: true,
    });
    reference?.setNativeProps({
      hasTVPreferredFocus: false,
    });
  }
};
